import React from 'react';

export default function IconLeftArrow() {
  return (
    <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M1.34326 8.34277L7.00011 13.9996" stroke="white" strokeWidth="2" strokeLinecap="round" />
      <path d="M1.34326 8.34277L7.00011 2.68592" stroke="white" strokeWidth="2" strokeLinecap="round" />
    </svg>
  );
}